import React from 'react';
import { Card, CardBody, Col } from 'reactstrap';
import { Link } from "react-router-dom";
import HomeOutlineIcon from 'mdi-react/HomeOutlineIcon';
import ToolTip from '../../../../../shared/components/ToolTip';

const ActiveRentalListings = (props) => {
	const { buildingRes, location } = props;
	const count = buildingRes && buildingRes.active_listings_rent > 0 ? buildingRes.active_listings_rent : 0;
	const base_url = location.pathname.replace('analysis', 'listings');
	return (
		<Col md={12} xl={3} lg={6} xs={6}>
			<Card>
				<Link to={base_url}>
					<CardBody className="dashboard__booking-card card__link">
						<div className="dashboard__booking-total-container">
							<h5 className="dashboard__booking-total-title">{count}</h5>
							<HomeOutlineIcon className="dashboard__trend-icon" />
						</div>
						<h5 className="dashboard__booking-total-description">Active Rental Listings
							<ToolTip title={"Number of rental listings currently marked active in this building."} />
						</h5>
					</CardBody>
				</Link>
			</Card>
		</Col>
	);
};

export default ActiveRentalListings;
